<template>
	<div class="fenBox">
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="pageNum"
			:page-sizes="pageSizes"
			:page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total"
		></el-pagination>
		<el-button @click="handleCurrentChange" style="margin-left: 10px" size="mini" type="primary">确定</el-button>
	</div>
</template>

<script>
export default {
	name: 'lunBo',
	props: {
		total: {
			type: Number,
			default: 0
		},
		lbHeight: {
			type: String,
			default: '501'
		},
		pSize: {
			type: Number,
			default: 10
		}
	},
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			pageSizes: [this.pSize, this.pSize * 2, this.pSize * 3, this.pSize * 4]
		};
	},
	methods: {
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pageSize = val;
			this.$emit('dataFn', {
				pageNum: this.pageNum,
				pageSize: val
			});
		},
		handleCurrentChange(val) {
			if (typeof val != 'number') {
				return;
			}
			console.log(`当前页: ${val}`, val);
			this.pageNum = val;
			this.$emit('dataFn', {
				pageNum: val,
				pageSize: this.pageSize
			});
		}
	},
	created() {
		this.pageSize = this.pSize;
	}
};
</script>
<style lang="scss" scoped>
.fenBox {
	height: 81px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
